/*用export把方法暴露出来*/
/*设置cookie*/
//存储信息
import * as access from '../config/access';
export function SetInfo(name, value, expires) {
	access.session(name, value);
};
/*读取信息*/
export function GetInfo(name) {
	let val = access.session(name);
	if (typeof val === 'object' && val) {
		return val[name]
	}
	return val;
};
/*删除信息*/
export function ClearInfo(name) {
	if (window.localStorage) {
		localStorage.removeItem(name);
	} else {
		setCookie(name, '', -1);
	}
};
/*删除所有的信息*/
export function ClearAllInfo() {
	if (window.localStorage) {
		localStorage.clear();
	} else {
		clearCookie();
	}
};
//存cookie
export function setCookie(name, value, expiredays) {
	access.session(name, value);
};

/*显示cookie*/
export function getCookie(name) {
	return access.session(name);
};
/*清除cookie*/
export function clearCookie() {
	var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
	if (keys) {
		for (var i = keys.length; i--;) {
			document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString();
		};
	};
};

/*日期转化*/
export function formatDate(date, fmt) {
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	let o = {
		'M+': date.getMonth() + 1,
		'd+': date.getDate(),
		'h+': date.getHours(),
		'm+': date.getMinutes(),
		's+': date.getSeconds()
	};
	for (let k in o) {
		if (new RegExp(`(${k})`).test(fmt)) {
			let str = o[k] + '';
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
		}
	}
	return fmt;
};
/*日期转化*/
export function formatDate001(date, fmt) {
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	}
	let o = {
		'M+': date.getMonth() + 1,
		'd+': date.getDate(),
		'h+': date.getHours(),
		'm+': date.getMinutes(),
		's+': date.getSeconds()
	};
	for (let k in o) {
		if (new RegExp(`(${k})`).test(fmt)) {
			let str = o[k] + '';
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
		}
	}
	return fmt;
};

function padLeftZero(str) {
	return ('00' + str).substr(str.length);
}

// 手机号验证
export function isvalidPhone(str) {
	const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
	return reg.test(str)
}
// 过滤空格
export function removeAllSpace(str) {
	const reg = /^\S*$/;
	return reg.test(str)
}
// 整数验证
export function integerNum(str) {
	const reg = /^[0-9]*$/;
	return reg.test(str)
}
// 金额验证
export function isMoney(str) {
	let reg = /^[0-9]+(.[0-9]{0,2})?$/;
	return reg.test(str)
}
// 非零正整数验证
export function positiveInteger(str) {
	const reg = /^\+?[1-9][0-9]*$/;
	return reg.test(str)
}
// 邮箱验证
export function email(str) {
	const reg = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	return reg.test(str)
}
// 英文验证
export function english(str) {
	const reg = /^[a-zA-Z]+$/;
	return reg.test(str)
}
// 座机验证
export function telephone(str) {
	const reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
	return reg.test(str)
}
// 网站验证
export function webUrl(str) {
	const reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
	return reg.test(str)
}

export function staticPhone(str) {
    const reg = /(^(0\d{2})-(\d{8})$)|(^(0\d{3})-(\d{7})$)|(^(0\d{2})-(\d{8})-(\d+)$)|(^(0\d{3})-(\d{7})-(\d+)$)/;
    return reg.test(str);
}

export function mobile(str) {
    const reg = /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/;
    return reg.test(str);
}
